// https://github.com/mapbox/frontend-optimized-trips/blob/master/src/formats/geojson.js
// const axios = require('axios');
// const axiosRetry = require('axios-retry');
// const polyline = require('@mapbox/polyline');
import axios from 'axios';
import axiosRetry from 'axios-retry';
import polyline from '@mapbox/polyline';
axiosRetry(axios, { retries: 3 });

class RouteGeometryClient {
  constructor() {
    this.token =
      process.env.REACT_APP_MAPBOX_ACCESS_TOKEN ||
      'pk.eyJ1IjoieXVsZXRpZGUiLCJhIjoiY2s3cHMyeWxtMDQwaDNmbXZkeTlvMnRmayJ9.mkYPHtQ5iLxGEufBPKOsBg';
    this.base_url = 'https://api.mapbox.com/directions/v5/mapbox/driving';
    // this.base_url =
    //   'https://api-directions-car-production.mapbox.com/directions/v5/mapbox/driving';
  }

  isPolyline(route) {
    return typeof route.geometry === 'string';
  }

  directionsToGeoJSON(route, properties = {}) {
    // const features = directions.routes.map(route => {
    const geometry = this.isPolyline(route)
      ? polyline.toGeoJSON(route.geometry, 6)
      : route.geometry;
    return geometry;
    // return turf.feature(geometry, properties);
  }

  formatRequest(points) {
    const fmt_points = points.map(coord => `${coord[0]},${coord[1]}`).join(';');
    return `${this.base_url}/${fmt_points}?access_token=${this.token}&overview=full&geometries=polyline6`;
  }

  async processSolution(solution) {
    console.debug(`processSolution`, solution);

    let coords = solution.routes[0].stops.map(stop => {
      return stop.coordinates;
    });

    // TODO remove this trimming and do multiple requests
    const directions = await this.fetchRouteGeometry(coords);
    // console.log('directions', directions);
    let route = directions.routes[0];
    solution.geometry = this.directionsToGeoJSON(route);
    solution.duration = route.duration;
    solution.distance = route.distance;
    return solution;
  }

  async fetchRouteGeometry(points) {
    console.debug(
      `event=fetchRouteGeometry request=${this.formatRequest(points)}`
    );
    const resp = await axios({
      method: 'get',
      url: this.formatRequest(points),
      responseType: 'json',
    });
    if (resp.status === 200) {
      return resp.data;
    } else {
      throw Error(resp);
    }
  }
}

// module.exports = new RouteGeometryClient();
export default new RouteGeometryClient();
